@if (true === isSmall) {
<div
    class="asset__icon"
    [ngClass]="{'asset__icon--selected': selected === true}"
    (click)="play($event)"
>
    <i class="fas fa-volume-up"></i>
</div>
} @if (isIconOnly) {
<i
    class="fas fa-volume-up"
    [ngClass]="{'icon--selected': selected === true}"
    (click)="play($event)"
></i>
}
<div
    [hidden]="isSmall || isIconOnly"
    id="audio-container"
    class="audio-container"
    #bbvmsContainer
></div>
